<template>
  <v-card class="mx-3" min-height="80%">
    <TicketFilterForm></TicketFilterForm>
    <TicketTable></TicketTable>
<!--    <v-tabs color="#FA1E95" grow v-model="tab">-->
<!--      <v-tab v-for="(item, i) in tabs" :key="i">-->
<!--        {{ item }}-->
<!--      </v-tab>-->
<!--      <v-tab-item>-->
<!--        <TicketForm></TicketForm>-->
<!--      </v-tab-item>-->

<!--      <v-tab-item>-->
<!--        <TicketFilterForm></TicketFilterForm>-->
<!--        <TicketTable></TicketTable>-->
<!--      </v-tab-item>-->
<!--    </v-tabs>-->
  </v-card>
</template>

<script>
import TicketTable from '@/modules/ticket/components/TicketTable.vue';
import TicketFilterForm from '@/modules/ticket/components/TicketFilterForm.vue';
import { mapActions, mapState } from 'vuex';
import { setPageTitle } from '@/helpers/utils';

export default {
  name: 'Ticket',
  components: {
    TicketTable,
    TicketFilterForm,
  },
  created() {
    setPageTitle('Ticket');
    this.getListTicketStatus();
  },
  computed: {
    ...mapState('ticket', ['listTicketStatus']),
  },
  methods: {
    ...mapActions('ticket', ['getListTicketStatus']),
  },
  data() {
    return {
    };
  },
};
</script>

<style scoped>

</style>
